import React from 'react'
import { Tabs } from 'react-bootstrap'
import PropTypes from 'prop-types'
import './style.sass'

const CustomTabs = ({children, defaultActiveKey}) => {
  return (
    <div className="custom-tabs-component-container">
      <Tabs defaultActiveKey={defaultActiveKey} className="mb-3">
        {children}
      </Tabs>
    </div>
  )
}

CustomTabs.propTypes = {
  children: PropTypes.node,
  defaultActiveKey: PropTypes.string
}

export default CustomTabs
